<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  <label>Please add an explanation:</label>
  <textarea
    [ngModel]="explanation"
    (ngModelChange)="onExplanationChange($event)"
    class="form-control"
  ></textarea>
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="!explanation" (click)="save()">Save</button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
